import { Component, OnInit, OnDestroy, AfterViewInit, Output, EventEmitter, ViewChild } from "@angular/core";
import { FormOfPaymentIssuerSecurityCode } from "../../..";
import { Subscription, Observable } from "rxjs";
import { FormOfPaymentIssuerSearch } from "src/app/core/models/form-of-payment-model";
import { SecurityGroupService } from "src/app/core/services/system-services/security-group.service";
import { SecurityGroupSecurityModel } from "src/app/core/models/security-model/security-group-security.model";
import { DateConverterService } from "src/app/core/utils/date-converter.service";
import { StatusReferenceModel } from "src/app/core/models/reference-model/reference-general-model";
import { DxDataGridComponent } from "devextreme-angular";
import { NavigationService } from "src/app/shared/utils/navigation";
import { FormOfPaymentIssuerUpdateStatusCode } from "../form-of-payment-issuer-search.model";
import { FormOfPaymentIssuerSearchService } from "../form-of-payment-issuer-search.service";

@Component({
    selector: 'op-form-of-payment-issuer-search-results',
    templateUrl: './form-of-payment-issuer-search-results.component.html',
})
export class FormOfPaymentIssuerSearchResultsComponent implements OnInit, OnDestroy, AfterViewInit {

    readonly ExportFileName = "Form of Payment Issuers"
    readonly PageSize = "A3";
    totalCount: number
    exportHeader: string[]
    exportData: any[]
    selectedRow: FormOfPaymentIssuerSearch

    focusing = false
    dataSource: FormOfPaymentIssuerSearch[]
    userSecurity: SecurityGroupSecurityModel
    userSecurity$: Observable<SecurityGroupSecurityModel>
    statusReferenceModels$: Observable<StatusReferenceModel[]>
    statusReferenceModels: StatusReferenceModel[]

    private subscriptions: Subscription[]

    @ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;
    @Output() onRefresh = new EventEmitter<never>()
    @Output() onUpdateStatusCode = new EventEmitter<FormOfPaymentIssuerUpdateStatusCode>()
    @Output() onNavigateDetail = new EventEmitter()

    constructor(private formOfPaymentIssuerSearchService: FormOfPaymentIssuerSearchService,
        private securityGroupService: SecurityGroupService,
        private dateConverterService: DateConverterService,
        private navigationService: NavigationService) {
    }
    ngOnInit(): void {
        this.subscriptions = []
        this.subscriptions.push(
            this.securityGroupService.userSecurityGroupSecurity.subscribe(response => {
                this.userSecurity = response.find(s => s.securityCode == FormOfPaymentIssuerSecurityCode)
                this.userSecurity$ = new Observable((observer) => observer.next(this.userSecurity))
            })
        )


        this.subscriptions.push(
            this.formOfPaymentIssuerSearchService.statusReferenceModels$.subscribe(response => {
                this.statusReferenceModels = response
                this.statusReferenceModels$ = new Observable((observer) => observer.next(this.statusReferenceModels))
            })
        )
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }
    ngAfterViewInit(): void {
        this.subscriptions.push(
            this.formOfPaymentIssuerSearchService.formOfPaymentIssuers$.subscribe(response => {
                if (response == null || response.length == 0) {
                    this.dataGrid.instance.clearFilter()
                }
                this.dataSource = response
            })
        )
    }

    updateStatusCode(record: FormOfPaymentIssuerSearch, statusCode: string): void {
        this.onUpdateStatusCode.emit({
            formOfPaymentIssuerCode: record.formOfPaymentIssuerCode,
            statusCode: statusCode
        })
    }

    toDateTimeFormat(value): string {
        if (new Date(value).getFullYear() != 1) {
             return this.dateConverterService.formatSystemDateTime(value);
        }
    }

    onContentReady(e): void {
        this.totalCount = e.component.totalCount()

        const filterExpr = this.dataGrid.instance.getCombinedFilter()
        const gridDataSource = this.dataGrid.instance.getDataSource()
        const filterDataSource = gridDataSource?.store().load({
            filter: filterExpr
        })

        const columns = this.dataGrid.instance.getVisibleColumns()
        const dataFields = Object.values(columns.map(item => item.dataField).filter(f => !!f))
        filterDataSource?.done((response: FormOfPaymentIssuerSearch[]) => {
            let rowNumber = 1
            this.exportData = response.map(r => {
                let model = {}
                model['no'] = rowNumber
                rowNumber++
                dataFields.map((v) => model[v] = r[v])
                return model
            })
        })
        this.exportHeader = columns.map(item => item.caption)
    }
    onRowClick(e): void {
        this.selectedRow = e.data
    }
    onRowDblClick(e): void {
        this.onRowClick(e)
        this.edit()
    }

    refresh(): void {
        this.onRefresh.emit()
    }

    new(): void {
        this.navigationService.navigate(`/main/settings/form-of-payment-issuer-detail`, null, false, {pageData: [] })
    }

    edit(): void {
        if (!this.selectedRow){
            return;
        }
        let params = { id: this.selectedRow.formOfPaymentIssuerCode, pageData: this.dataSource, currentPageIndex:  this.getRowNoByModel(this.selectedRow)}
        this.onNavigateDetail.emit(params)
    }

    private getRowNoByModel(model: FormOfPaymentIssuerSearch) {
        return this.dataSource?.indexOf(model) + 1;
    }
}
